import { UpToButExcludingDate } from '@/helpers/UpToButExcludingDate'
import {
    DepartmentResource,
    ShiftPlanningResource,
    ShiftResource,
    ShiftViewModel,
    TrackResource,
} from '@/models'
import { transformDepartmentResource } from '@/services/DepartmentService/transformDepartmentResource'
import { transformShiftPlanningResource } from '@/services/ShiftPlanningService/transformShiftPlanningResource'
import { transformTrackResource } from '@/services/TrackService/transformTrackResource'

export function transformShiftResource(
    shift: ShiftResource,
    shiftPlannings: ShiftPlanningResource[] = [],
    tracks: TrackResource[] = [],
    department?: DepartmentResource,
): ShiftViewModel {
    return {
        department: department ? transformDepartmentResource(shift.department, shift.department.group) : undefined,
        end: new UpToButExcludingDate(shift.end).transformToUpToAndIncludingDate(),
        id: shift.id,
        peopleLimit: shift.peopleLimit,
        shiftPlannings: shiftPlannings
            .map((shiftPlanning) => transformShiftPlanningResource(shiftPlanning, shiftPlanning.user)),
        start: new Date(shift.start),
        statusForCurrentUser: shift.statusForCurrentUser,
        tracks: tracks
            .map((track) => transformTrackResource(track)),
    }
}
